import * as Logger from 'js-logger';
import { ILogLevel } from 'js-logger/src/types';

// Web configs set the logging level and Webforms makes it available on the window.
/* istanbul ignore next */
function getLoggingLevel(): ILogLevel {
  return Logger[window.loggingLevel] || Logger.ERROR;
}

const defaultHandler = Logger.createDefaultHandler();

Logger.useDefaults();

/* istanbul ignore next */
Logger.setHandler((messages, context) => {
  defaultHandler(messages, context);
});

Logger.setLevel(getLoggingLevel());

export { Logger };
